import { useEffect, useRef } from "react";
import { useTrainingStore } from "../stores/trainingStore";
import { useAudio } from "./useAudio";

export const useTimer = () => {
  const { isActive, isPaused, currentPhase, tick } = useTrainingStore();
  const { playPhaseChange } = useAudio();
  const prevPhaseRef = useRef(currentPhase);

  useEffect(() => {
    if (!isActive || isPaused) return;

    const interval = setInterval(() => {
      tick();
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive, isPaused, tick]);

  useEffect(() => {
    if (isActive && prevPhaseRef.current !== currentPhase) {
      playPhaseChange(currentPhase);
    }
    prevPhaseRef.current = currentPhase;
  }, [currentPhase, isActive, playPhaseChange]);
};
